import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { googleSearchProduct, gptNameSearchProduct, updateGoogleEstimateValue } from "../../services/api";
import { secretKey } from "../../services/config";
import EncryptDecrypt from "../../utils/encrypt&decrypt";

const namespace = "google";

// Async thunk for Google lens search
export const searchProduct = createAsyncThunk(
   `${namespace}/searchProduct`,
   async ({ postData }, { rejectWithValue }) => {
      try {
         let payload = EncryptDecrypt.encryptdata(postData, secretKey);
         const data = await googleSearchProduct({ payload });
         return data;
      } catch (error) {
         return rejectWithValue(error.response);
      }
   }
);

// Async thunk for ChatGPT name search
export const searchGPTName = createAsyncThunk(
   `${namespace}/searchGPTName`,
   async ({ searchData }, { rejectWithValue }) => {
      try {
         let payload = EncryptDecrypt.encryptdata(searchData, secretKey);
         const data = await gptNameSearchProduct({ payload });
         return data;
      } catch (error) {
         return rejectWithValue(error.response);
      }
   }
);

// Async thunk for Google lens search
export const updateValue = createAsyncThunk(
   `${namespace}/updateValue`,
   async ({ postData }, { rejectWithValue }) => {
      try {
         let payload = EncryptDecrypt.encryptdata(postData, secretKey);
         const data = await updateGoogleEstimateValue({ payload });
         return data;
      } catch (error) {
         return rejectWithValue(error.response);
      }
   }
);

const googleSearch = createSlice({
   name: namespace,
   initialState: {
      googleSearchResult: [],
      googleSearchLoading: false,
      googleSearchSuccess: false,
      googleSearchError: false,
      googleSearchErrorMessage: "",
      NameSearchResult: [],
      NameSearchLoading: false,
      NameSearchSuccess: false,
      NameSearchError: false,
      NameSearchErrorMessage: "",
      googleUpdateValueSuccess: false,
      googleUpdateValueError: false,
      googleUpdateValueErrorMessage: "",
   },
   reducers: {
      resetSuccessFlag: (state, action) => {
         const { flag } = action.payload;
         state[flag] = false;
      },
      resetUpdateStatus: (state, action) => {
         state.googleUpdateValueSuccess = false;
         state.googleUpdateValueError = false;
         state.googleUpdateValueErrorMessage = "";
         state.googleSearchLoading = false;
         state.googleSearchSuccess = false;
         state.NameSearchLoading = false;
         state.NameSearchSuccess = false;
      },
   },
   extraReducers: builder => {
      builder
         // Handle get google lens records
         .addCase(searchProduct.pending, state => {
            state.googleSearchResult = [];
            state.googleSearchLoading = true;
            state.googleSearchSuccess = false;
            state.googleSearchError = false;
            state.googleSearchErrorMessage = "";
         })
         .addCase(searchProduct.fulfilled, (state, action) => {
            console.log(action, action.payload.data?.successfulResults, "googleresponse");

            state.googleSearchResult = action.payload.data?.successfulResults;
            state.googleSearchSuccess = true;
            state.googleSearchLoading = false;
         })
         .addCase(searchProduct.rejected, (state, action) => {
            const payload = action.payload;
            state.googleSearchError = true;
            state.googleSearchErrorMessage =
               "errors" in payload ? payload.errors[0].message : payload.message;
            state.googleSearchLoading = false;
         })
         .addCase(searchGPTName.pending, state => {
            state.NameSearchResult = [];
            state.NameSearchLoading = true;
            state.NameSearchSuccess = false;
            state.NameSearchError = false;
            state.NameSearchErrorMessage = "";
         })
         .addCase(searchGPTName.fulfilled, (state, action) => {
            console.log(action, action.payload.data?.results, "resultsresults");

            state.NameSearchResult = action.payload.data?.results;
            state.NameSearchSuccess = true;
            state.NameSearchLoading = false;
         })
         .addCase(searchGPTName.rejected, (state, action) => {
            const payload = action.payload;
            state.NameSearchError = true;
            state.NameSearchErrorMessage =
               "errors" in payload ? payload.errors[0].message : payload.message;
            state.NameSearchLoading = false;
         })

         .addCase(updateValue.pending, state => {
            state.googleSearchLoading = true;
            state.googleUpdateValueSuccess = false;
            state.googleUpdateValueError = false;
            state.googleUpdateValueErrorMessage = "";
         })
         .addCase(updateValue.fulfilled, (state, action) => {
            state.googleUpdateValueSuccess = true;
            state.googleSearchLoading = false;
         })
         .addCase(updateValue.rejected, (state, action) => {
            const payload = action.payload;
            state.googleUpdateValueError = true;
            state.googleUpdateValueErrorMessage =
               "errors" in payload ? payload.errors[0].message : payload.message;
            state.googleSearchLoading = false;
         });
   },
});

export const { resetSuccessFlag, resetUpdateStatus } = googleSearch.actions;

export const googleSearchSelector = state => state[namespace];

export default googleSearch.reducer;
